import { render, staticRenderFns } from "./BasicReferenceField.vue?vue&type=template&id=c2fbff74&scoped=true&"
import script from "./BasicReferenceField.vue?vue&type=script&lang=js&"
export * from "./BasicReferenceField.vue?vue&type=script&lang=js&"
import style0 from "./BasicReferenceField.vue?vue&type=style&index=0&id=c2fbff74&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fbff74",
  null
  
)

export default component.exports